module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p4-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "pbreak"
  })]), _c('h2', {
    staticClass: "h2fm"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "imagec1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p5-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Foreword#foreword",
      "id": "rforeword"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Part01#pt1",
      "id": "rpt1"
    }
  }, [_vm._v("DOMAINE TEMPIER: THE VINEYARD AND THE PEYRAUDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Part02#pt2",
      "id": "rpt2"
    }
  }, [_vm._v("THE VIGNERON’S YEAR: SEASONS AND MENUS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part03#pt3",
      "id": "rpt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LULU’S KITCHEN: RECIPES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#ch1",
      "id": "rch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02#ch2",
      "id": "rch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APÉRITIF AND AMUSE-GUEULES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "id": "rch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROVENÇAL CELEBRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "id": "rch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "id": "rch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FISH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "id": "rch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEATS, POULTRY, GAME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "id": "rch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VEGETABLES, SALADS, GRAINS, PASTA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "id": "rch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHEESES AND DESSERTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part04#pt4",
      "id": "rpt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WINE-TASTING NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Index#index",
      "id": "rindex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0